import React from 'react';
import Konfio from '../assets/WorkExperience/konfio-logo.png'

const Loading = () => {
    return (
        <img alt="loading" src={Konfio} style={{height: 100, width: 1000}} />
    );
}

export default Loading;